(function() {
    function isIosSafari() {
        return /iP(ad|hone|od)/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent);
    }

    function fixIosDoubleTapIssue() {
        // if (!isIosSafari()) return;

        document.addEventListener('touchend', function(e) {
        const target = e.target;
        const tag = target.tagName.toLowerCase();

        if (tag === 'button' || tag === 'a' || tag === 'label') {
            e.preventDefault();
            target.click();
        } else if (tag === 'span' && target.closest('label')) {
            e.preventDefault();
            target.closest('label').click(); 
        }
        }, { passive: false });
    }


    document.addEventListener('DOMContentLoaded', fixIosDoubleTapIssue);
})();